import type { TPricing } from "~/components/cards/Pricing.vue";

export const crmPrices: Array<TPricing> = [
    {
      title: "بسته پایه",
      desc: "شروع حرفه‌ای مدیریت فروش",
      img: "/img/new/pricing/paye.webp",
      amounts: [
        { 
            title: "به ازای هر کاربر در ماه / پرداخت سالانه", 
            value: [
              { max: 1, price: '384' },
              { max: 2, price: '265' },
              { max: 3, price: '219' },
              { max: 4, price: '173' },
              { max: 9, price: '144' },
              { max: 19, price: '131' },
              { max: 29, price: '125' },
              { max: 49, price: '121' },
              { max: 99, price: '119' },
              { max: 199, price: '119' },
              { max: 299, price: '119' },
              { min: 300, price: '119' },
            ], 
            unit: "هزار تومان" 
        },
      ],
      features: [
        { title: "پنل مدیریتی پیشرفته", value: true },
        { title: "اپلیکیشن تخصصی", value: true },
        { title: "مدیریت مشتریان", value: true },
        { title: "سرنخ‌های فروش", value: true },
        { title: "مدیریت فرصت‌های فروش", value: true },
        { title: "وظایف و پیگیری‌ها", value: true },
        { title: "محصولات و انبار", value: true },
        { title: "صدور فاکتور و پیش فاکتور", value: true },
      ]
    },
    {
      title: "بسته عملیاتی",
      desc: "مدیریت منسجم تیم و فرایند فروش",
      img: "/img/new/pricing/amalyati.webp",
      amounts: [
        { 
            title: "به ازای هر کاربر در ماه / پرداخت سالانه", 
            value: [
              { max: 1, price: '418' },
              { max: 2, price: '318' },
              { max: 3, price: '263' },
              { max: 4, price: '202' },
              { max: 9, price: '173' },
              { max: 19, price: '137' },
              { max: 29, price: '131' },
              { max: 49, price: '127' },
              { max: 99, price: '125' },
              { max: 199, price: '125' },
              { max: 299, price: '125' },
              { min: 300, price: '125' },
            ], 
            unit: "هزار تومان" 
        },
      ],
      features: [
        { title: "همه ویژگی‌های بسته پایه+", value: true, isBoldText: true },
        { title: "مدیریت دپارتمان و اعضای تیم", value: true },
        { title: "مدیریت نقش، سطوح و حقوق", value: true },
        { title: "تیکتینگ", value: true },
        { title: "گزارش گیری پیشرفته تیکت‌ها", value: true },
        { title: "قابلیت اتصال به مرکز تلفن نواتل", value: true },
        { title: "کلیک‌تو‌کال با اتصال به مرکز تلفن", value: true },
        { title: "پاپ‌آپ تماس با اتصال به مرکز تلفن", value: true },
      ]
    },
    {
      title: "بسته یکپارچه",
      desc: "همه تعاملات مشتری در یک بستر",
      img: "/img/new/pricing/yekparche.webp",
      boldCard: {
        type: 'popular',
        title: 'محبوب‌ترین',
      },
      amounts: [
        { 
            title: "به ازای هر کاربر در ماه / پرداخت سالانه", 
            value: [
              { max: 1, price: '544' },
              { max: 2, price: '414' },
              { max: 3, price: '342' },
              { max: 4, price: '263' },
              { max: 9, price: '225' },
              { max: 19, price: '178' },
              { max: 29, price: '171' },
              { max: 49, price: '168' },
              { max: 99, price: '165' },
              { max: 199, price: '165' },
              { max: 299, price: '165' },
              { min: 300, price: '165' },
            ], 
            unit: "هزار تومان" 
        },
      ],
      features: [
        { title: "همه ویژگی‌های بسته عملیاتی+", value: true, isBoldText: true },
        { title: "تاریخچه تعاملات و پروفایل ۳۶۰ درجه", value: true },
        { title: "اتوماسیون گردش‌کار", value: true },
        { title: "پنل پیامکی با خط اختصاصی", value: true },
        { title: "وب‌سرویس پنل پیامکی", value: true },
        { title: "چت آنلاین یکپارچه", value: true },
        { title: "اتصال به واتس‌اپ", value: true },
        { title: "یکپارچه‌سازی کانال‌های ارتباطی", value: true }
      ]
    },
    {
      title: "بسته فراگیر",
      desc: "CRM و مرکز تماس در یک راهکار کامل",
      img: "/img/new/pricing/faragir.webp",
      boldCard: {
        type: 'suggest',
        title: 'پیشنهاد نواتل',
      },
      amounts: [
        { 
            title: "به ازای هر کاربر در ماه / پرداخت سالانه", 
            value: [
              { max: 1, price: '807' },
              { max: 2, price: '584' },
              { max: 3, price: '452' },
              { max: 4, price: '349' },
              { max: 9, price: '307' },
              { max: 19, price: '288' },
              { max: 29, price: '280' },
              { max: 49, price: '274' },
              { max: 99, price: '269' },
              { max: 199, price: '269' },
              { max: 299, price: '269' },
              { min: 300, price: '269' },
            ],
            unit: "هزار تومان" 
        },
      ],
      features: [
        { title: "همه ویژگی‌های بسته یکپارچه+", value: true, isBoldText: true },
        { title: "کلیه قابلیت‌های مرکز تماس", value: true },
        { title: "تلفن گویای چند سطحی", value: true },
        { title: "صف تماس با استراتژی‌های مختلف", value: true },
        { title: "مانیتورینگ زنده کاربران", value: true },
        { title: "نجوا، ورود و کنترل به مکالمات", value: true },
        { title: "گزارش‌های پیشرفته تماس", value: true },
        { title: "اتصال به آی‌پی‌فون", value: true }
      ]
    }
];


export const crmComparePlans = {
  header: ['', 'بسته پایه', 'بسته عملیاتی', 'بسته یکپارچه', 'بسته فراگیر'],
  data: [
    {
      title: 'ویژگی های اصلی',
      items: [
        ['فضای ابری', '0.5', '1', '2', '5'],
        ['پروفایل', '10,000', '20,000', '30,000', '50,000'],
        ['تعداد فرصت فروش', '10,000', '20,000', '30,000', '50,000'],
        ['پنل مدیریتی پیشرفته', true, true, true, true],
        ['اتصال از طریق API به امکانات مختلف پنل', true, true, true, true],
        ['اپلیکیشن تخصصی', true, true, true, true],
        ['تاریخچه تعاملات', false, false, true, true],
        ['نمایش پاپ آپ تماس', false, true, true, true]
      ]
    },
    {
      title: 'اشخاص',
      items: [
        ['ایجاد مخاطب', true, true, true, true],
        ['ایجاد مخاطبان با فایل اکسل', true, true, true, true],
        ['خروجی اکسل', true, true, true, true],
        ['جستجو و فیلتر پیشرفته', true, true, true, true],
        ['امکان عملیات گروهی (حذف، ایجاد وظیفه و اختصاص به کاربر)', true, true, true, true],
        ['کلیک تو کال', false, true, true, true],
        ['تعریف وظیفه', true, true, true, true],
        ['ثبت تاریخ آخرین ارتباط', true, true, true, true],
        ['تعیین کارشناس پیگیری', true, true, true, true],
        ['مدیریت لیبل‌های پروفایل', true, true, true, true],
        ['تاریخچه تعاملات', false, false, true, true],
        ['حذف پروفایل', true, true, true, true],
        ['ثبت اطلاعات ارتباطی', true, true, true, true],
        ['ثبت اطلاعات شخصی', true, true, true, true],
        ['ثبت اطلاعات کسب و کار و حوزه فعالیت', true, true, true, true],
        ['ایجاد تیکت از پروفایل', false, false, true, true],
        ['ایجاد فاکتور و پیش فاکتور', true, true, true, true],
        ['ایجاد فرصت فروش', true, true, true, true],
        ['بارگذاری مدارک هویتی', true, true, true, true],
        ['ایجاد ارتباط بین شخص و شرکت', true, true, true, true],
        ['بارگذاری فایل های پیوست', true, true, true, true],
        ['تاریخچه تماس ها', true, true, true, true],
        ['تاریخچه وب چت', 'قابل خرید', 'قابل خرید', true, true],
        ['تاریخچه واتس‌اپ', 'قابل خرید', 'قابل خرید', true, true],
        ['تاریخچه پیامک ها', 'قابل خرید', 'قابل خرید', true, true],
        ['تعریف وظیفه', true, true, true, true],
        ['تعریف فیلد های اختصاصی', true, true, true, true],
        ['تاریخچه تغییرات', true, true, true, true],
        ['ثبت یادداشت', true, true, true, true]
      ]
    },
    {
      title: 'شرکت‌ها',
      items: [
        ['ایجاد مخاطب', true, true, true, true],
        ['ایجاد مخاطبان با فایل اکسل', true, true, true, true],
        ['خروجی اکسل', true, true, true, true],
        ['جستجو و فیلتر پیشرفته', true, true, true, true],
        ['امکان عملیات گروهی (حذف، ایجاد وظیفه و اختصاص به کاربر)', true, true, true, true],
        ['کلیک تو کال', false, true, true, true],
        ['تعریف وظیفه', true, true, true, true],
        ['ثبت تاریخ آخرین ارتباط', true, true, true, true],
        ['تعیین کارشناس پیگیری', true, true, true, true],
        ['مدیریت لیبل‌های پروفایل', true, true, true, true],
        ['تاریخچه تعاملات', false, false, true, true],
        ['حذف پروفایل', true, true, true, true],
        ['ثبت اطلاعات ارتباطی', true, true, true, true],
        ['ثبت اطلاعات شرکتی', true, true, true, true],
        ['ثبت اطلاعات کسب و کار و حوزه فعالیت', true, true, true, true],
        ['ایجاد تیکت از پروفایل', false, false, true, true],
        ['ایجاد فاکتور و پیش فاکتور', true, true, true, true],
        ['ایجاد فرصت فروش', true, true, true, true],
        ['بارگذاری مدارک هویتی', true, true, true, true],
        ['ایجاد ارتباط بین شخص و شرکت', true, true, true, true],
        ['بارگذاری فایل های پیوست', true, true, true, true],
        ['تاریخچه تماس ها', true, true, true, true],
        ['تاریخچه وب چت', 'قابل خرید', 'قابل خرید', true, true],
        ['تاریخچه واتس‌اپ', 'قابل خرید', 'قابل خرید', true, true],
        ['تاریخچه پیامک ها', 'قابل خرید', 'قابل خرید', true, true],
        ['تعریف وظیفه', true, true, true, true],
        ['تعریف فیلد های اختصاصی', true, true, true, true],
        ['تاریخچه تغییرات', true, true, true, true],
        ['ثبت یادداشت', true, true, true, true]
      ]
    },
    {
      title: 'تاریخچه تعاملات شرکت',
      items: [
        ['فیلتر گذاری درحالت های مختلف در گزارش گیری تاریخچه', false, false, true, true],
        ['قابلیت کلیک تو کال جهت تسریع ارتباط با مخاطب یا سرنخ', false, false, true, true],
        ['مشاهده تاریخچه تعاملات', false, false, true, true],
        ['افزودن مخاطب', false, false, true, true],
        ['افزودن سرنخ', false, false, true, true]
      ]
    },
    {
      title: 'سرنخ‌ها',
      items: [
        ['ایجاد سرنخ', true, true, true, true],
        ['ایجاد سرنخ با فایل اکسل', true, true, true, true],
        ['آرشیو سرنخ بصورت تکی و گروهی', true, true, true, true],
        ['جستجو و فیلتر پیشرفته', true, true, true, true],
        ['امکان عملیات گروهی (حذف، ایجاد وظیفه و اختصاص به کاربر)', true, true, true, true],
        ['کلیک تو کال', false, true, true, true],
        ['تعریف وظیفه', true, true, true, true],
        ['ثبت تاریخ آخرین ارتباط', true, true, true, true],
        ['تعیین کارشناس پیگیری', true, true, true, true],
        ['تاریخچه تعاملات', true, true, true, true],
        ['حذف سرنخ', true, true, true, true],
        ['پروفایل اختصاصی', true, true, true, true],
        ['تبدیل یک سرنخ به شخص و شرکت', true, true, true, true],
        ['ثبت اطلاعات ارتباطی', true, true, true, true],
        ['تاریخچه تغییرات', true, true, true, true],
        ['نمایش اطلاعات کمپین', true, true, true, true],
        ['تاریخچه تماس ها', true, true, true, true],
        ['تاریخچه وب چت', 'قابل خرید', 'قابل خرید', true, true],
        ['تاریخچه واتس‌اپ', 'قابل خرید', 'قابل خرید', true, true],
        ['تاریخچه پیامک ها', 'قابل خرید', 'قابل خرید', true, true],
        ['ثبت یادداشت', true, true, true, true]
      ]
    },
    {
      title: 'فرصت های فروش',
      items: [
        ['ایجاد فرصت فروش', true, true, true, true],
        ['خروجی اکسل', true, true, true, true],
        ['نمایش بصورت بُرد کانبان', true, true, true, true],
        ['کلیک تو کال', false, true, true, true],
        ['نمایش بصورت کارت', true, true, true, true],
        ['نمایش بصورت جدولی', true, true, true, true],
        ['جستجو و فیلتر پیشرفته', true, true, true, true],
        ['آرشیو فرصت فروش', true, true, true, true],
        ['عملیات گروهی (حذف)', true, true, true, true],
        ['سورتینگ متناسب با فیلتر های دلخواه', true, true, true, true],
        ['تعیین کارشناس پیگیری', true, true, true, true],
        ['تعیین عناوین فرصت های فروش', true, true, true, true],
        ['تعیین اولویت برای فرصت فروش', true, true, true, true],
        ['ایجاد ارتباط با سایر بخش های CRM', true, true, true, true],
        ['تاریخچه تغییرات', true, true, true, true],
        ['تاریخچه تماس ها', true, true, true, true],
        ['تاریخچه وب چت', 'قابل خرید', 'قابل خرید', true, true],
        ['تاریخچه واتس‌اپ', 'قابل خرید', 'قابل خرید', true, true],
        ['تاریخچه پیامک ها', 'قابل خرید', 'قابل خرید', true, true],
        ['تعریف وظیفه', true, true, true, true],
        ['ثبت یادداشت', true, true, true, true],
        ['ایجاد فاکتور و پیش فاکتور', true, true, true, true],
        ['تعریف محصول برای فرصت فروش', true, true, true, true],
        ['مرحله بندی برای فرصت فروش تا زمان نهایی شدن آن', true, true, true, true],
        ['تعریف دلایل موفقیت و عدم موفقیت', true, true, true, true]
      ]
    },
    {
      title: 'وظیفه‌ها',
      items: [
        ['تعریف وظیفه', true, true, true, true],
        ['جستجو و فیلتر پیشرفته', true, true, true, true],
        ['تعیین عناوین وظیفه', true, true, true, true],
        ['تعیین نوع وظیفه', true, true, true, true],
        ['تعیین مهلت انجام، یادآوری و مدت زمان وظایف', true, true, true, true],
        ['ایجاد ارتباط با سایر بخش های CRM', true, true, true, true],
        ['تاریخچه تغییرات', true, true, true, true],
        ['حذف وظیفه', true, true, true, true],
        ['تغییر وضعیت وظیفه', true, true, true, true],
        ['ثبت نظر', true, true, true, true]
      ]
    },
    {
      title: 'تیکتینگ',
      items: [
        ['ایجاد تیکت', false, false, true, true],
        ['خروجی اکسل', false, false, true, true],
        ['تغییر حالت نمایش', false, false, true, true],
        ['کلیک تو کال', false, false, true, true],
        ['جستجو و فیلتر پیشرفته', false, false, true, true],
        ['آرشیو تیکت', false, false, true, true],
        ['عملیات گروهی (حذف)', false, false, true, true],
        ['سورتینگ متناسب با فیلتر های دلخواه', false, false, true, true],
        ['تعریف وظیفه', false, false, true, true],
        ['تعیین کارشناس پیگیری', false, false, true, true],
        ['تعیین عناوین تیکت', false, false, true, true],
        ['ایجاد ارتباط با سایر بخش های CRM', false, false, true, true],
        ['ثبت توضیحات تیکت', false, false, true, true],
        ['تعیین نوع تیکت', false, false, true, true],
        ['ثبت حس مخاطب', false, false, true, true],
        ['تاریخچه تماس ها', false, false, true, true],
        ['تاریخچه وب چت', false, false, true, true],
        ['مشاهده چت های صورت گرفته از طریق واتس‌اپ', false, false, true, true],
        ['مشاهده پیامک های ارسال شده', false, false, true, true],
        ['تاریخچه واتس‌اپ', false, false, true, true],
        ['ثبت یادداشت', false, false, true, true],
        ['پاسخ به تیکت', false, false, true, true],
        ['تعیین وضعیت تیکت', false, false, true, true]
      ]
    },
    {
      title: 'فاکتور/پیش فاکتور',
      items: [
        ['ایجاد فاکتور و پیش فاکتور', true, true, true, true],
        ['ایجاد فاکتور و پیش فاکتور با فایل اکسل', true, true, true, true],
        ['جستجو و فیلتر پیشرفته', true, true, true, true],
        ['کلیک تو کال', false, true, true, true],
        ['خروجی اکسل و پی دی اف', true, true, true, true],
        ['حذف و ابطال فاکتور و پیش فاکتور', true, true, true, true],
        ['تاریخچه تغییرات', true, true, true, true],
        ['ارسال فاکتور و پیش فاکتور از طریق واتس اپ', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال فاکتور و پیش فاکتور از طریق پیامک', 'قابل خرید', 'قابل خرید', true, true],
        ['تنظیمات عمومی', true, true, true, true],
        ['تعیین قالب شخصی سازی شده', true, true, true, true],
        ['تنظیمات پیشرفته', true, true, true, true]
      ]
    },
    {
      title: 'محصولات',
      items: [
        ['ایجاد محصول', true, true, true, true],
        ['ایجاد محصول با فایل اکسل', true, true, true, true],
        ['تعریف دسته بندی', true, true, true, true],
        ['تعریف محصول متغیر', true, true, true, true],
        ['جستجو و فیلتر پیشرفته', true, true, true, true],
        ['تعیین نوع و واحد اندازه گیری', true, true, true, true],
        ['تعیین قیمت، کد و ارز', true, true, true, true],
        ['تاریخچه تغییرات', true, true, true, true],
        ['حذف محصول', true, true, true, true],
        ['فعال سازی و غیرفعال سازی', true, true, true, true]
      ]
    },
    {
      title: 'انبار',
      items: [
        ['ایجاد انبار', true, true, true, true],
        ['تعریف محصول متغیر', true, true, true, true],
        ['ورود محصول به انبار', true, true, true, true],
        ['خروجی اکسل', true, true, true, true],
        ['تاریخچه تغییرات', true, true, true, true],
        ['حذف و آرشیو انبار', true, true, true, true]
      ]
    },
    {
      title: 'اتوماسیون گردش کار',
      items: [
        ['فعال سازی گردش کار', false, false, true, true],
        ['مشاهده جزئیات و تغییرات درخصوص اجرای گردش کار', false, false, true, true],
        ['مشاهده گزارش گردش کار', false, false, true, true],
        ['مشاهده سوابق و تاریخچه تغییرات', false, false, true, true]
      ]
    },
    {
      title: 'اپلیکیشن تخصصی',
      items: [
        ['نسخه نیتیو اندروید، ویندوز، iOS و لینوکس', true, true, true, true],
        ['مشاهده پروفایل مخاطب', true, true, true, true],
        ['هولد تماس', false, false, false, true],
        ['ترنسفر تماس', false, false, false, true],
        ['تماس داخلی به داخلی', false, false, false, true],
        ['پیام‌رسانی، ایجاد گروه و کانال، ارسال فایل', true, true, true, true],
        ['تماس تصویری', true, true, true, true],
        ['شارژ کیف پول', true, true, true, true],
        ['تعریف وظیفه', true, true, true, true],
        ['ارسال پیامک تکی', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال پیامک گروهی', 'قابل خرید', 'قابل خرید', true, true],
        ['تنظیمات پیشرفته تماس', true, true, true, true],
        ['تنظیم سرشماره', false, false, false, true],
        ['رعایت الزامات رمزگذاری اطلاعات', true, true, true, true],
        ['تنطیمات میکروفون', true, true, true, true],
        ['تنظیمات زنگ تماس', true, true, true, true],
        ['برقراری تماس بدون اینترنت بین الملل', true, true, true, true],
        ['مشاهده وضعیت مرکز تماس', false, false, false, true],
        ['تنظیم Swipe Actions برای تماس، مخاطبین و پیام ها', true, true, true, true],
        ['ارسال پیام به واتس‌اپ', 'قابل خرید', 'قابل خرید', true, true]
      ]
    },
    {
      title: 'تنظیمات تماس',
      items: [
        ['تعیین شروط زمانی بر اساس ماه، روز و ساعت', false, false, false, true],
        ['تعریف شماره دایورتی', false, false, false, true],
        ['پیامگیر صوتی', false, false, false, true],
        ['تنظیمات ضبط مکالمات', false, false, false, true],
        ['تعریف لیست سیاه', false, false, false, true],
        ['تعیین مقصد تماس', false, false, false, true]
      ]
    },
    {
      title: 'تنظیمات صف',
      items: [
        ['تعریف صف تماس', false, false, false, true],
        ['استراتژی‌های مختلف پاسخگویی', false, false, false, true],
        ['انتخاب آوای انتظار', false, false, false, true],
        ['تعیین زمان انتظار', false, false, false, true],
        ['تعیین عملیات پس از پایان زمان انتظار', false, false, false, true],
        ['فعالسازی ضبط مکالمه', false, false, false, true],
        ['فعالسازی نظرسنجی', false, false, false, true],
        ['فعال‌سازی تماس امن ورودی', false, false, false, true],
        ['اعلام تعداد نفرات در صف', false, false, false, true],
        ['اعلام میانگین زمان انتظار', false, false, false, true]
      ]
    },
    {
      title: 'تلفن گویا (IVR)',
      items: [
        ['تعریف منو', false, false, false, true],
        ['منوهای چند سطحی', false, false, false, true],
        ['تعریف سناریو برای هر گزینه', false, false, false, true],
        ['داخلی اختصاصی 3 و 4 رقمی', false, false, false, true],
        ['تعیین عملیات پس از اتمام IVR', false, false, false, true],
        ['اتصال به آخرین اپراتور', false, false, false, true]
      ]
    },
    {
      title: 'مانیتورینگ مرکز تلفن',
      items: [
        ['پیشخوان', false, false, false, true],
        ['مانیتورینگ کاربران', false, false, false, true],
        ['نجوا', false, false, false, true],
        ['کنترل تماس', false, false, false, true],
        ['ورود به مکالمه', false, false, false, true],
        ['والبورد', false, false, false, true]
      ]
    },
    {
      title: 'گزارشات مرکز تلفن',
      items: [
        ['سوابق تماس', false, false, false, true],
        ['وضعیت تماس', false, false, false, true],
        ['عملکرد پاسخگویی کاربر', false, false, false, true],
        ['ضبط مکالمات', false, false, false, true],
        ['نتایج نظرسنجی مکالمات', false, false, false, true],
        ['تماس‌های از دست رفته', false, false, false, true],
        ['گزارش های پیشرفته', false, false, false, true]
      ]
    },
    {
      title: 'نمودار ها',
      items: [
        ['نمودار پراکندگی تماس‌ها', false, false, false, true],
        ['نمودار تاریخچه هزینه‌ها', false, false, false, true],
        ['نمودار صبر مشتری', false, false, false, true]
      ]
    },
    {
      title: 'امکانات عمومی مرکز تلفن',
      items: [
        ['اتصال داخلی ها به شماره های چهار و پنج رقمی', false, false, false, true],
        ['پنهان سازی Caller ID تماس‌های ورودی', false, false, false, true],
        ['امکان شماره گیری مستقیم داخلی ها در شماره های ۴ و ۵ رقمی', false, false, false, true],
        ['فعال سازی نظر سنجی تماس های خروجی', false, false, false, true],
        ['کال‌پیک آپ', false, false, false, true],
        ['فعال سازی ضبط تماس های خروجی', false, false, false, true],
        ['فعال سازی ضبط تماس های داخلی', false, false, false, true],
        ['برقراری تماس از طریق API', false, false, false, true],
        ['برقراری تماس امن دوطرفه', false, false, false, 'قابل خرید']
      ]
    },
    {
      title: 'تنظیمات کاربری',
      items: [
        ['تعریف کاربر', true, true, true, true],
        ['تعریف کاربر IP-Phone', false, false, false, true],
        ['مدیریت نقش، سطوح و حقوق اختصاصی', false, true, true, true],
        ['تعریف دپارتمان', false, true, true, true],
        ['نمایش پاپ آپ تماس', false, true, true, true],
        ['یکپارچه‌سازی با واتس اپ', 'قابل خرید', 'قابل خرید', true, true]
      ]
    },
    {
      title: 'پنل پیامکی',
      items: [
        ['تعریف مخاطب', 'قابل خرید', 'قابل خرید', true, true],
        ['تعریف مخاطبان با فایل اکسل', 'قابل خرید', 'قابل خرید', true, true],
        ['ایجاد، ویرایش و حذف گروه', 'قابل خرید', 'قابل خرید', true, true],
        ['جستجو و فیلتر گروه‌ها', 'قابل خرید', 'قابل خرید', true, true],
        ['جستجو و فیلتر مخاطبان', 'قابل خرید', 'قابل خرید', true, true],
        ['تعریف عناوین پیش‌فرض', 'قابل خرید', 'قابل خرید', true, true],
        ['تعریف متن پیش‌فرض پیامک', 'قابل خرید', 'قابل خرید', true, true],
        ['زمان‌بندی ارسال پیامک', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال تکی پیامک', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال به گروه مخاطبان', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال انبوه با فایل اکسل', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال پیامک متناظر', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال پیامک پارامتریک', 'قابل خرید', 'قابل خرید', true, true],
        ['ارسال OTP', 'قابل خرید', 'قابل خرید', true, true],
        ['امکانات ویژه برنامه نویسان', 'قابل خرید', 'قابل خرید', true, true],
        ['گزارش ارسال', 'قابل خرید', 'قابل خرید', true, true],
        ['گزارش دریافت', 'قابل خرید', 'قابل خرید', true, true],
        ['پاسخ به پیامک های دریافتی', 'قابل خرید', 'قابل خرید', true, true],
        ['ایجاد لید و فرصت فروش از پیامک های دریافتی', 'قابل خرید', 'قابل خرید', true, true]
      ]
    },
    {
      title: 'وب چت',
      items: [
        ['تعریف وب سایت', 'قابل خرید', 'قابل خرید', true, true],
        ['تعریف اپراتور و سطوح دسترسی', 'قابل خرید', 'قابل خرید', true, true],
        ['ایجاد دپارتمان', 'قابل خرید', 'قابل خرید', true, true],
        ['شخصی سازی', 'قابل خرید', 'قابل خرید', true, true],
        ['پاسخگویی از طریق پنل و اپلیکیشن', 'قابل خرید', 'قابل خرید', true, true],
        ['نمایش تاریخچه گفتگوها', 'قابل خرید', 'قابل خرید', true, true],
        ['ثبت سرنخ و تیکت از گفتگو', 'قابل خرید', 'قابل خرید', true, true],
        ['جستجو و فیلتر گفتگوها', 'قابل خرید', 'قابل خرید', true, true]
      ]
    },
    {
      title: 'ارزیابی عملکرد',
      items: [
        ['ثبت ارزیابی بر اساس KPIها', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['پخش مکالمه ضبط‌شده', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['جستجو و فیلتر ارزیابی‌ها', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['ثبت نمره و ارزیابی تماس', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['گزارش ارزیابی کاربران', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['گزارش نمرات ارزیابی', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید']
      ]
    },
    {
      title: 'فکس ابری',
      items: [
        ['ارسال و دریافت فکس', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['گزارش فکس‌های ارسالی', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['گزارش فکس‌های دریافتی', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید']
      ]
    },
    {
      title: 'ویدئو کنفرانس',
      items: [
        ['کنفرانس عمومی و خصوصی', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['گزارش تماس‌های ویدیویی', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید'],
        ['جستجو و فیلتر', 'قابل خرید', 'قابل خرید', 'قابل خرید', 'قابل خرید']
      ]
    }
  ]
};